export default __webpack_public_path__ + "static/media/bg-preloader.2e310f09.jpg";